import { render, staticRenderFns } from "./NoNotifications.vue?vue&type=template&id=590e63ff&scoped=true&"
import script from "./NoNotifications.vue?vue&type=script&lang=js&"
export * from "./NoNotifications.vue?vue&type=script&lang=js&"
import style0 from "./NoNotifications.vue?vue&type=style&index=0&id=590e63ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e63ff",
  null
  
)

export default component.exports